export const getTgWebApp = () => window?.Telegram?.WebApp
export const getTgUser = () => getTgWebApp().initDataUnsafe?.user
export const getTgUserId = () => getTgUser()?.id
